export enum RG_CONFIGURATION_TYPE {
    TIMEOUT = 0,
    REALITY_CHECK = 1,
    SESSION_TIMER = 2,
    LOSS_LIMIT = 3,
    BET_LIMIT = 4,
    LOGIN_LIMITS = 5,
    PRODUCT_BET_LIMIT = 6,
    PRODUCT_LOSS_LIMIT = 7,
    AUTOMATIC_WITHDRAWAL_LIMIT = 8,
    SINGLE_BET_LIMIT = 9,
    INACTIVITY_TIMEOUT = 10,
    DEPOSIT_COUNT_LIMITS = 18,
    PLAYER_DATA_REVIEW = 22
}

export enum RG_LIMIT_PERIOD {
    DAY = 1,
    WEEK = 2,
    MONTH = 3
}

export enum RG_LIMIT_PERIOD_WITH_SESSION {
    SESSION = 1,
    DAY = 2,
    WEEK = 3,
    MONTH = 4
}

export enum RG_LIMIT_PREDEFINED_TYPE {
    DISABLED = 'disabled',
    ENABLED = 'enabled',
    FORCED = 'forced'
}
